module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data03-34130ea961c1774b2ce53b91dda66ce2.png";